import React from 'react';

class IndexPlayer extends React.PureComponent {

    constructor(props) {

        super(props);

        this.state = {

            playing: true,
            speed: 1,
        };

        this.handleDocumentKeyDown = this.handleDocumentKeyDown.bind(this);
        this.handleIndexChange = this.handleIndexChange.bind(this);
        this.handleFirstClick = this.handleFirstClick.bind(this);
        this.handleLastClick = this.handleLastClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
        this.handlePauseClick = this.handlePauseClick.bind(this);
        this.handlePlay = this.handlePlay.bind(this);
        this.handlePlayClick = this.handlePlayClick.bind(this);
        this.handlePreviousClick = this.handlePreviousClick.bind(this);
        this.handleSpeedChange = this.handleSpeedChange.bind(this);
    }

    componentDidMount() {

        this.handlePlay();

        document.addEventListener('keydown', this.handleDocumentKeyDown);
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.state.playing !== prevState.playing)
            this.handlePlay();

        if (!this.state.playing && this.timer)
            clearTimeout(this.timer);
    }

    componentWillUnmount() {

        if (this.timer)
            clearTimeout(this.timer);

        document.removeEventListener('keydown', this.handleDocumentKeyDown);
    }

    handleDocumentKeyDown(e) {

        if (e.keyCode === 37) { // Arrow left

            e.preventDefault();
            this.handlePreviousClick();
        }
        else if (e.keyCode === 39) { // Arrow right

            e.preventDefault();
            this.handleNextClick();
        }
    }

    handleIndexChange(index) {

        if (this.props.onIndexChange)
            this.props.onIndexChange(index);
    }

    handleFirstClick() {

        this.handleIndexChange(0);
    }

    handleLastClick() {

        this.handleIndexChange(this.props.items.length - 1);
    }

    handleNextClick() {

        this.handleIndexChange(IndexPlayer.keepIndexWithinBounds(this.props.index + 1, this.props.items.length));
    }

    handlePauseClick() {

        this.setState({playing: false});
    }

    handlePlay() {

        if (this.state.playing) {

            this.handleIndexChange(IndexPlayer.keepIndexWithinBounds(this.props.index + 1, this.props.items.length));
            this.timer = setTimeout(this.handlePlay, 1000 / this.state.speed);
        }
    }

    handlePlayClick() {

        this.setState({playing: true});
    }

    handlePreviousClick() {

        this.handleIndexChange(IndexPlayer.keepIndexWithinBounds(this.props.index - 1, this.props.items.length));
    }

    handleSpeedChange(e) {

        this.setState({speed: Number(e.target.value)});
    }

    render() {

        return (

            <div className="photo-controls d-flex flex-column align-items-center text-light">
                <div className="d-flex align-items-center">
                    0.5x
                    <input type="range" min="0.5" max="2" step="0.01" className="mx-2" value={this.state.speed} onChange={this.handleSpeedChange} style={{flex: 1}}/>
                    2x
                </div>
                <div className="btn-group mt-2">
                    <button type="button" className="btn btn-light" disabled={this.state.playing || this.props.index === 0} onClick={this.handleFirstClick}><i className="fas fa-step-backward"/></button>
                    <button type="button" className="btn btn-light" disabled={this.state.playing} onClick={this.handlePreviousClick}><i className="fas fa-backward"/></button>
                    {this.state.playing && <button type="button" className="btn btn-light" onClick={this.handlePauseClick}><i className="fas fa-pause"/></button>}
                    {!this.state.playing && <button type="button" className="btn btn-light" onClick={this.handlePlayClick}><i className="fas fa-play"/></button>}
                    <button type="button" className="btn btn-light" disabled={this.state.playing} onClick={this.handleNextClick}><i className="fas fa-forward"/></button>
                    <button type="button" className="btn btn-light" disabled={this.state.playing || this.props.index === this.props.items.length - 1} onClick={this.handleLastClick}><i className="fas fa-step-forward"/></button>
                </div>
            </div>
        );
    }

    static keepIndexWithinBounds(newIndex, arrayLength) {

        if (newIndex < 0) return arrayLength - 1;
        if (newIndex > arrayLength - 1) return 0;

        return newIndex;
    }
}

export default IndexPlayer;



// WEBPACK FOOTER //
// ./src/components/IndexPlayer.js